'use strict'

var hexRegEx = /([0-9]|[a-f])/gim

module.exports = function (input) {
  return typeof input === 'string' &&
    (input.match(hexRegEx) || []).length === input.length
}
